export default {
  API_PREFIX: '/contractgenerator',
};
